import { inject, Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, MaybeAsync, Router, RouterStateSnapshot, UrlTree }from '@angular/router';
import { AppStoreService } from '@core/store/app-store.service';
import { PermissionType } from '@core/enums/permission-type.enum';
import { UserProfileService } from '@core/service/user-profile.service';
import { ClientDto } from '@core/api';

@Injectable({
    providedIn: 'root',
})
export class NoDapReactivateGuard {
    private readonly _appStoreService = inject(AppStoreService);
    private readonly _router = inject(Router);
    private readonly _userProfileService = inject(UserProfileService);

    canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot): MaybeAsync<boolean | UrlTree> {
        const client = this._userProfileService.client();
        
        if(client != null){
            const token = this._appStoreService.token();
            if(
                client.state !== undefined
                && token != null
                && (
                    client.state === ClientDto.StateEnum.Deleted
                    || client.state === ClientDto.StateEnum.UnderDeletion
                )
            ){
                token.privileges = [PermissionType.INACTIVE_CLIENT];
                return true;
            }
        }

        return this._router.createUrlTree(['/dashboard']);
    }
}
